import { Injectable } from '@angular/core';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';

@Injectable()
export class LinkService {

  db;

  constructor() {
    this.db = firebase.firestore();
  }

  async getUserLinks(uid) {
    let links = []
    let tempLinks = await this.db.collection("profiles").doc(uid).collection("links").get();
    tempLinks.forEach((doc) => {
        links.push(doc.data());
    });
    return links;
  }

  getUserLinksSub(uid) {
    return this.db.collection("profiles").doc(uid).collection("links")
  }

  async getUserLink(linkId, uid) {
    let link = await this.db.collection("profiles").doc(uid).collection("links").doc(linkId).get();
    return link.data();
  }

  async addUserLink(link, uid) {
    if (!link || !uid) return;
    if (link && link.$id) {
      this.db.collection("profiles").doc(uid).collection("links").doc(link.$id).update(link);
    } else {
      let linkId = await this.db.collection("profiles").doc(uid).collection("links").doc();
      link.$id = linkId.id;
      this.db.collection("profiles").doc(uid).collection("links").doc(linkId.id).set(link);
      return link.$id;
    }
    return;
  }

  deleteUserLink(link, uid) {
    this.db.collection("profiles").doc(uid).collection("links").doc(link.$id).delete();
  }

}



// WEBPACK FOOTER //
// ./src/services/link.service.ts